// Pure helpers for the batch timeframe-confirmation modal. The backend is the
// source of truth for grouping/guarding, but the UI mirrors that logic so it
// can (a) only send orders already on a route and (b) warn that whole-stop
// confirmation will also confirm unselected orders sharing a stop with a
// selection — matching `customerStops` + whole-stop grouping in
// batchTimeframeConfirmation.f.js.

// Assignment comes from the leg-specific route id the planning context injects.
const isAssigned = (o) => (o?.crossdock_leg === 'pickup' ? !!o.pickup_route_id : !!o.dropoff_route_id);
const routeIdOf = (o) => (o?.crossdock_leg === 'pickup' ? o.pickup_route_id : o.dropoff_route_id);

const isCustomerStop = (stop) => {
    if (!stop) return false;
    if (stop.type === 'DROPOFF') return !stop.end && !(stop.returns?.length > 0);
    if (stop.type === 'PICKUP') return !stop.start && stop.returns?.length > 0;
    return false;
};

export const analyzeBatchSelection = (selectedOrderObjs = [], routes = []) => {
    const assigned = selectedOrderObjs.filter(isAssigned);
    const unassigned = selectedOrderObjs.filter((o) => !isAssigned(o));

    const assignedOrderIds = [...new Set(assigned.map((o) => o.order_id))];
    const selectedIdSet = new Set(assignedOrderIds);

    const routesById = Object.fromEntries((routes || []).map((r) => [r.route_id, r]));

    // order_id -> order_number, for naming stopmates in the warning
    const numberById = {};
    for (const r of routes || []) {
        for (const m of r.orders || []) {
            if (m.order?.order_id) numberById[m.order.order_id] = m.order.order_number;
        }
    }

    const stopmateIds = new Set();
    for (const o of assigned) {
        const route = routesById[routeIdOf(o)];
        if (!route) continue;
        for (const stop of route.stopsByRouteId || []) {
            if (!isCustomerStop(stop)) continue;
            if (!(stop.orders || []).includes(o.order_id)) continue;
            for (const sid of stop.orders) {
                if (!selectedIdSet.has(sid)) stopmateIds.add(sid);
            }
        }
    }

    return {
        assignedOrderIds,
        unassignedOrderNumbers: unassigned.map((o) => o.order_number),
        willAlsoConfirmOrderNumbers: [...stopmateIds].map((id) => numberById[id] || id),
    };
};
